import dayjs from 'dayjs';
import { get } from 'lodash';

const validate80271 = ({
  productId,
  schemes, // 所有计划
  currentScheme, // 当前选择的计划
  singlePerson, // 只检验单个被保人，录入人员信息的时候使用
  restrict,
  validStartDate,
}) => {
  console.log(`💠 特殊产品${productId}校验`);
  // 大于66岁的被保人
  let hasGt66Person = false;
  // 按生效日还是投保日判断年龄， 0 投保日， 1 生效日既保险起期
  const judgeDay = restrict.insureAgeCalWay === 1 ? dayjs(validStartDate) : dayjs().startOf('day');
  if (singlePerson) {
    hasGt66Person =
      dayjs(singlePerson.birthDay).isBefore(judgeDay.subtract(66, 'year')) ||
      dayjs(singlePerson.birthDay).isSame(judgeDay.subtract(66, 'year'));
  } else {
    const allPersonList = currentScheme.professions.reduce((list, profession) => {
      return list.concat(profession.personsInfo || []);
    }, []);
    hasGt66Person = allPersonList.find(
      (person) =>
        dayjs(person.birthDay).isBefore(judgeDay.subtract(66, 'year')) ||
        dayjs(person.birthDay).isSame(judgeDay.subtract(66, 'year'))
    );
  }
  if (!hasGt66Person) {
    return '';
  }
  const deadClause = currentScheme.planClauseList.find(
    (clause) => clause.clauseCode === 'GP8027164714297'
  );
  const deadAmount = get(deadClause, 'selected.value', 0);
  if (+deadAmount < 100000 || +deadAmount > 500000) {
    return `${
      hasGt66Person.insuredName ? `${hasGt66Person.insuredName}-` : ''
    }66-70周岁仅能选择10万-50万身故保额`;
  }
  return '';
};

const validateSuddenDead80216 = ({
  productId,
  currentScheme, // 当前选择的计划
  singlePerson, // 只检验单个被保人，录入人员信息的时候使用
  restrict,
  validStartDate,
}) => {
  const suddenDeadClause = currentScheme.planList.find(
    (item) => item.clauseCode === 'GP8021679099379'
  );
  let isOver49 = false;
  // 猝死身故保险选了有保额的
  if (suddenDeadClause.selected.insured == 0) {
    return '';
  }
  if (singlePerson) {
    // 遍历所有职业
    isOver49 = dayjs().diff(singlePerson.birthDay, 'year') > 49;
    if (isOver49) {
      return `${singlePerson.insuredName}-49周岁以上不可投${suddenDeadClause.clauseName}`;
    }
  } else {
    const allPersonList = currentScheme.professions.reduce((list, profession) => {
      return list.concat(profession.personsInfo || []);
    }, []);
    const isOver49Person = allPersonList.find(
      (person) => dayjs().diff(person.birthDay, 'year') > 49
    );
    if (isOver49Person) {
      return `${isOver49Person.insuredName}-49周岁以上不可投${suddenDeadClause.clauseName}`;
    }
  }
  return '';
};

const validate80291 = ({
  productId,
  schemes, // 所有计划
  currentScheme, // 当前选择的计划
  singlePerson, // 只检验单个被保人，录入人员信息的时候使用
  restrict,
  validStartDate,
}) => {
  console.log(`💠 特殊产品${productId}校验`);
  const suddenDeadClause = currentScheme.planClauseList.find(
    (item) => item.clauseCode === 'GP8029179097054'
  );
  if (suddenDeadClause.selected.value == 0) {
    return '';
  }
  // 大于49岁的被保人
  let hasGt49Person = false;
  // 按生效日还是投保日判断年龄， 0 投保日， 1 生效日即保险起期
  const judgeDay = restrict.insureAgeCalWay === 1 ? dayjs(validStartDate) : dayjs().startOf('day');
  if (singlePerson) {
    hasGt49Person =
      dayjs(singlePerson.birthDay).isBefore(judgeDay.subtract(49, 'year')) ||
      dayjs(singlePerson.birthDay).isSame(judgeDay.subtract(49, 'year'));
  } else {
    const allPersonList = currentScheme.professions.reduce((list, profession) => {
      return list.concat(profession.personsInfo || []);
    }, []);
    hasGt49Person = allPersonList.find(
      (person) =>
        dayjs(person.birthDay).isBefore(judgeDay.subtract(49, 'year')) ||
        dayjs(person.birthDay).isSame(judgeDay.subtract(49, 'year'))
    );
  }
  if (hasGt49Person) {
    return `${
      hasGt49Person.insuredName ? `${hasGt49Person.insuredName}-` : ''
    }49周岁及以上不可投保猝死责任`;
  }
  return '';
};

/**
 * 特殊产品选择责任的各种校验，比如某类职业只能选某个保额范围
 * 某个年龄只能选择某个保额范围
 * 例：【80271美亚】66-70周岁仅能选择10万-50万身故保额
 */
export const specialPersonValidateFuncMap = {
  80271: validate80271,
  80216: validateSuddenDead80216,
  80291: validate80291,
};

// 101 和美亚产品走这个逻辑，保险止期需要取前一天的23:59:59
export const NEED_SUBTRACT_ONE_DAY_PRODUCT_IDS = [101, 80187, 80202, 80204, 80212, 80271];

export const specialHandleSubmitParams = (params) => {
  if (params.validEndDate) {
    if (NEED_SUBTRACT_ONE_DAY_PRODUCT_IDS.includes(+params.productId)) {
      // 如果保险止期是以 59 结尾的，则加 1 秒
      const endDate = new Date(params.validEndDate);
      if (endDate.getSeconds() === 59) {
        params.validEndDate += 1000;
      }
    }
  }
  return params;
};

// 美亚产品
export const isMeiyaProduct = (productId) => {
  if (!productId) {
    return false;
  }
  return [80202, 80204, 80212, 80271].includes(+productId);
};

// 计算保费需要传人员信息的特殊产品
export const calNeedPersonsProductIds = ['80294', '80291'];

// 扩展责任哪些责任默认不需要选中
export const factorRateAllNotDefault = (productId, factorRateItem) => {
  return ['80230', '80281'].includes(productId + '');
};

// 企业联系人信息需要填写身份证，但是代理人已签约的，不显示，因为服务端自己会取代理人身份证号
export const needContactIdCardButHide = (productId) => {
  if (!productId) {
    return false;
  }
  return isMeiyaProduct(productId) || [80295].includes(+productId);
};

export const specialClauseTips = {
  '80209_GP801294': '高空作业最高可保50万',
};



// WEBPACK FOOTER //
// ./src/util/special.js